import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from 'react';
import cn from 'classnames';
import TrendIcon from 'svg/trend.svg';
import { KPI_LEVELS } from '../../constants';
const Icon = ({ level })=>{
    if (level === KPI_LEVELS.NEUTRAL || level === KPI_LEVELS.TARGET) return null;
    return /*#__PURE__*/ _jsx(TrendIcon, {
        className: cn({
            rotate180: level === KPI_LEVELS.LOW
        })
    });
};
export default /*#__PURE__*/ memo(Icon);
